.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.label {
  font: var(--hs-type-label);
  letter-spacing: var(--hs-label-ls);
  color: var(--hs-color-text-primary);
}
.input {
  width: 100%;
  min-height: var(--hs-field-height);
  padding: var(--hs-spacing-3) var(--hs-spacing-4);
  border: 1px solid var(--hs-color-border-default);
  border-radius: var(--hs-radius-md);
  background: var(--hs-color-bg-surface);
  color: var(--hs-color-text-primary);
  font: var(--hs-type-body);
  resize: vertical;
  transition:
    border-color 120ms ease,
    box-shadow 120ms ease;
}
.input::placeholder {
  color: var(--hs-color-text-tertiary);
  opacity: 1;
}
.input:hover:not(:disabled) {
  border-color: var(--hs-color-border-strong);
}
.input:focus-visible {
  outline: none;
  border-color: var(--hs-color-primary-default);
  box-shadow: var(--hs-focus-lavender);
}
.input:disabled {
  background: var(--hs-color-bg-muted);
  opacity: 0.6;
  cursor: not-allowed;
}
.hint {
  margin: 0;
  font: var(--hs-type-body-s);
  color: var(--hs-color-text-secondary);
}

/* What is typed is wrong: the border says so, and the field is marked for assistive technology. */
.invalid,
.invalid:hover:not(:disabled) {
  border-color: var(--hs-color-danger-default);
}
/* The field's name for assistive technology only, where the layout says it otherwise
   (a language's code beside a translation). */
.hiddenLabel {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
.monospace {
  font: var(--hs-type-mono);
  font-size: 13px;
  line-height: 1.6;
}
